module.exports = __webpack_public_path__ + "img/12.f1ca1987.jpg";